import { BREAKPOINTS } from '../config';
import { initSlider } from './splide-sett';

const { mqTouch } = BREAKPOINTS;

const mq = window.matchMedia(`(max-width: ${mqTouch}px)`);

const autoplaySplides = document.querySelectorAll('.autoplay-splide');

autoplaySplides.forEach(container => {
  const splide = initSlider(container, {
    type: 'fade',
    updateOnMove: false,
    perPage: 1,
    rewind: true,
    autoplay: true,
    interval: 7000,
    pauseOnHover: true,

    drag: false, // Отключаем перетаскивание слайда мышью
    swipe: false, // Отключаем свайпы на мобильных устройствах
    keyboard: false, // Отключаем управление стрелками клавиатуры
    wheel: false, // Отключаем прокрутку колесом мыши
  });

  const arrows = container.querySelector('.arrows');
  const arrowsPrev = container.querySelector('.arrows__prev');
  const arrowsNext = container.querySelector('.arrows__next');
  const arrowLoader = container.querySelector('.arrow-loader');
  const progressCircle = arrowLoader?.querySelector('.progress');

  if (!arrowLoader || !progressCircle) return;

  const duration = splide.options.interval || 5000;

  function resetLoader() {
    progressCircle.style.animation = 'none';
    progressCircle.getBoundingClientRect();
  }

  function startLoader() {
    resetLoader();
    progressCircle.style.animation = `progress-circle ${duration}ms linear infinite`;
  }

  function pauseLoader() {
    resetLoader();
    progressCircle.style.animationPlayState = 'paused';
  }

  startLoader();

  splide.on('autoplay:play', startLoader);
  splide.on('autoplay:pause', pauseLoader);

  function handleClick() {
    startLoader();
  }

  function handleMouseEnter() {
    splide.Components.Autoplay.pause();
    pauseLoader();
  }

  function handleMouseLeave() {
    splide.Components.Autoplay.play();
    startLoader();
  }

  function addMobileListeners() {
    arrowsPrev?.addEventListener('click', handleClick);
    arrowsNext?.addEventListener('click', handleClick);

    arrows?.removeEventListener('mouseenter', handleMouseEnter);
    arrows?.removeEventListener('mouseleave', handleMouseLeave);
  }

  function addDesktopListeners() {
    arrowsPrev?.removeEventListener('click', handleClick);
    arrowsNext?.removeEventListener('click', handleClick);

    arrows?.addEventListener('mouseenter', handleMouseEnter);
    arrows?.addEventListener('mouseleave', handleMouseLeave);
  }
  function checkMode() {
    if (mq.matches) {
      addMobileListeners();
    } else {
      addDesktopListeners();
    }
  }

  checkMode();
  mq.addEventListener('change', checkMode);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      splide.Components.Autoplay.pause();
    } else {
      splide.Components.Autoplay.play();
    }
  });
});
